/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_8_QInputs */

const en_mk_pricing_faq_8_q = /** @type {(inputs: Mk_Pricing_Faq_8_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are these prices final?`)
};

const id_mk_pricing_faq_8_q = /** @type {(inputs: Mk_Pricing_Faq_8_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah harga ini sudah final?`)
};

/**
* | output |
* | --- |
* | "Are these prices final?" |
*
* @param {Mk_Pricing_Faq_8_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_8_q = /** @type {((inputs?: Mk_Pricing_Faq_8_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_8_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_8_q(inputs)
	return en_mk_pricing_faq_8_q(inputs)
});